import { LocalSettingsType } from '../types/local-settings.ts';
import LocalSettings from '../../.local-settings.json';
export default  () => {
    const settings = LocalSettings as LocalSettingsType;
    if(window?.location?.hostname?.includes('localhost')) return settings?.domainName;

    return window?.location?.hostname
}
